export const widgetEnum = {
  Desktop: 'desktop',
  Mobile: 'mobile',
};

export const ParkingLabelStatus = {
  OPEN: 'Open',
  CLOSED: 'Closed',
  NEARING_CAPACITY: 'Nearing capacity',
  FULL: 'Full',
};

export const FlightLabelStatus = {
  NONE: 0,
  ON_TIME: 1,
  EARLY: 2,
  DELAYED: 3,
  CANCELLED: 4,
  ARRIVED: 5,
  DEPARTED: 6,
  UNKNOWN: 7,
};

/**
 * Open/closed status for POIs with operation hours.
 * Separate from ParkingLabelStatus as parking has domain-specific states (NEARING_CAPACITY, FULL).
 */
export const PoiOpenStatus = {
  OPEN: 'open',
  CLOSED: 'closed',
  OPENING_SOON: 'opening-soon',
  CLOSING_SOON: 'closing-soon',
} as const;

export type PoiOpenStatusType = (typeof PoiOpenStatus)[keyof typeof PoiOpenStatus];
